module.exports = __webpack_public_path__ + "static/media/Questlogoheader.67d646c9.png";